import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'hq-print-container',
    templateUrl: './print-container.component.html',
    styleUrls: ['./print-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PrintContainerComponent {
}
